// Brand → logo URL mapping. Logos render in white via cdn.simpleicons.org (?color=fff)
// Fallback: a generic VAG mark / wordmark if brand is empty.

export const BRANDS = {
  audi: {
    label: "Audi",
    color: "#FFFFFF",
    logo: "https://cdn.simpleicons.org/audi/ffffff",
  },
  vw: {
    label: "Volkswagen",
    color: "#FFFFFF",
    logo: "https://cdn.simpleicons.org/volkswagen/ffffff",
  },
  skoda: {
    label: "Škoda",
    color: "#4BA82E",
    logo: "https://cdn.simpleicons.org/skoda/4BA82E",
  },
  seat: {
    label: "SEAT",
    color: "#FFFFFF",
    logo: "https://cdn.simpleicons.org/seat/ffffff",
  },
  bmw: {
    label: "BMW",
    color: "#0066B1",
    logo: "https://cdn.simpleicons.org/bmw/0066B1",
  },
  mercedes: {
    label: "Mercedes-Benz",
    color: "#000000",
    // SimpleIcons does not have a Mercedes slug — using a local PNG of the star logo.
    logo: "/brands/mercedes.png",
    logoDark: "/brands/mercedes.png",   // same file works on dark backgrounds (transparent star)
  },
  "mercedes-pkw": {
    label: "Mercedes-Benz Osobné",
    color: "#000000",
    logo: "/brands/mercedes.png",
    logoDark: "/brands/mercedes.png",
  },
  "mercedes-lkw": {
    label: "Mercedes-Benz Nákladné",
    color: "#000000",
    logo: "/brands/mercedes.png",
    logoDark: "/brands/mercedes.png",
  },
};

// Client-side fallback heuristic that mirrors the backend detect_brand() logic.
// Used if a product's `brand` field has not been populated yet.
export function detectBrandFromSku(sku) {
  if (!sku) return "";
  const s = String(sku).trim().toUpperCase().replace(/\s+/g, "");
  if (s.startsWith("000") || s.startsWith("00")) return "";
  const p2 = s.slice(0, 2);
  const p3 = s.slice(0, 3);
  if ([
    "4A","4B","4D","4E","4F","4G","4H","4L","4M","4N","4S","4Z",
    "8B","8D","8E","8H","8J","8K","8L","8N","8P","8R","8T","8U","8V","8W","8X","8Y","8Z","9A",
  ].includes(p2)) return "audi";
  if (["1U","1Z","3T","3U","5E","5J","5L","5Q","6V","6Y","7E"].includes(p2) || ["5JA","5JB","565","566","57A"].includes(p3)) return "skoda";
  if (["1L","1M","1P","5F","5P","6F","6J","6L","6P"].includes(p2) || ["6JU"].includes(p3)) return "seat";
  if ([
    "1H","1J","1K","1Q","1S","1T","2D","2E","2H","2K","2N",
    "3A","3B","3C","3D","3G","3H",
    "5C","5G","5K","5N","5T",
    "7D","7H","7L","7M","7N","7P","7R",
  ].includes(p2)) return "vw";
  if (s[0] === "8" || s[0] === "4") return "audi";
  return "";
}

// Returns the URL to use for a small dark logo (suitable on white background).
export function darkLogoFor(brand) {
  if (!brand) return null;
  if (brand.logoDark) return brand.logoDark;
  // SimpleIcons CDN trick: any /ffffff or color suffix can be swapped to /333333
  if (brand.logo && brand.logo.includes("cdn.simpleicons.org")) {
    return brand.logo.replace(/\/[0-9a-fA-F]{6}$/, "/333333");
  }
  return brand.logo;
}

export function brandFor(product) {
  const b = (product?.brand || "").toLowerCase();
  if (BRANDS[b]) return { key: b, ...BRANDS[b] };
  const detected = detectBrandFromSku(product?.sku);
  if (detected && BRANDS[detected]) return { key: detected, ...BRANDS[detected] };
  return null;
}
